module.exports = __webpack_public_path__ + "static/media/color-palette.a751be7f.svg";